/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { vappContainer } from '@/application';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';
import { logger as log } from '@common/logger';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const signInUser = async (context: any, event: any) => {
  const currentState = 'SIGN_IN_USER';
  const method = 'signIn';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      console.log(`next action in signIn:`, context['SEND_OTP']?.payload);
      let _payload = {
        ...event?.payload,
        nextAction: context['SEND_OTP']?.payload?.nextAction,
        role: context['SEND_OTP']?.payload.role?.find(
          (item) => item?.name === 'purchaser'
        )?.uuid,
      };
      //disable for actual login
      const content = await srv.agent.getSignInUserProps(_payload);
      log.log(MODULE_NAME, 'userProfile:', content);
      if (content && content?.accessToken) {
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', content, 'local');
        } else {
          storageSrv.set('userProfile', content, 'session');
        }
        return resolve({
          key: 'SIGN_IN_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else if (content && content?.signInToken) {
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', content, 'local');
        } else {
          storageSrv.set('userProfile', content, 'session');
        }
        return resolve({
          key: 'SIGN_IN_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'SIGN_IN_USER_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      toast.error(err?.message);
      return reject({
        key: 'SIGN_IN_USER_FAILED',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
